import { GlobalWorkerOptions, version } from 'pdfjs-dist';

let configured = false;

export function ensurePdfWorkerConfigured(): void {
    if (configured || typeof window === 'undefined') {
        return;
    }
    GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/build/pdf.worker.min.mjs`;
    configured = true;
}
